import { useSelector } from 'react-redux'
import useViewport from '../../hooks/useViewport'
import { selectActiveItem } from '../../store/selectors/navigation'
import { NavigationComponents } from '../../types/navigation'
import { DesktopHeader } from './Header/DesktopHeader'
import { MobileHeader } from './Header/MobileHeader/MobileHeader'
import { MobileSearchHeader } from './Header/MobileSearchHeader/MobileSearchHeader'

interface AppHeaderProps {
  enableAgentDropdown: boolean
  className?: string
}

export const AppHeader = ({ enableAgentDropdown, className }: AppHeaderProps) => {
  const { isMediumOrAbove } = useViewport()
  const activeItem = useSelector(selectActiveItem)

  const userIsInASearchPage = () => {
    return (
      activeItem === NavigationComponents.SEARCH_HOMES ||
      activeItem === NavigationComponents.FAVORITE_LISTINGS ||
      activeItem === NavigationComponents.SAVED_SEARCHES ||
      activeItem === NavigationComponents.LISTING
    )
  }

  if (isMediumOrAbove) {
    return <DesktopHeader className={className} enableAgentDropdown={enableAgentDropdown} />
  } else {
    return userIsInASearchPage() ? (
      <MobileSearchHeader className={className} enableAgentDropdown={enableAgentDropdown} />
    ) : (
      <MobileHeader enableAgentDropdown={enableAgentDropdown} />
    )
  }
}
